const projects = [
    {
      id: "loanterra",
      title: "DevOps for Loanterra (2023-2025)",
      imagesFolder: "/assets/loanterra",
      langs: [],
      software: ["SQL", "AWS"],
      description: `
        - Setup Loanterra Cloud environment with Okta for authentication and resource provisioning.\n\n
        - Ensured SOC2 Compliance through implementation of security controls and documentation.\n\n
        - DNS setup for mail server and custom vanity urls.\n\n
        - Integrated with Turnkey Lender for Loan management.\n\n
        - Built an automated backup SQL ingester and tester on AWS to ingest SQL backups from TurnKey's Azure environment.\n\n
        - Multiple Email tenancy migrations.\n\n
        - Assessed old site for cost optimizations (identified payments being charged for free wordpress addons).
      `
    },
    {
      id: "fecal-vision-model",
      title: "Fecal Vision Model for Veterinary Services (2022)",
      imagesFolder: "/assets/fecal-vision-model",
      langs: ["C++", "Python", "Js"],
      software: ["TensorFlow", "Express", "React", "QuPath", "OpenCV"],
      description: `
        - Over 1 year I developed a vision model using TensorFlow that was ~90% accurate (sufficient for medical diagnoses) in fecal egg counts using standard McMaster method fecal slides. This reduced slide analysis time from 20 minutes down to 5 minutes per sample.\n\n
        
        - Commercial alternatives like WSI systems start around $90,000USD, making this a cost-effective solution.\n\n
        
        - I modified a microscope to automate slide scanning and created data pipeline for high-quality slide scans for training purposes. Used OpenCV for image preprocessing\n\n
        
        - Using QuPath's scripting capabilities and sample annotated slides, I created a pipeline where the veterinarian only needed to take slide scans using a custom modified microscope, place the scans in a network folder, and receive analysis results in Excel format.\n\n
      `
    },
    {
      id: "orchard-market",
      title: "Order Picking Software for Orchard Market (2021)",
      imagesFolder: "/assets/orchard-market",
      langs: ["Js", "Python", "C#", "Bash", "VBA script"],
      software: ["Tesseract", "OpenCV", "Croptracker", "Produce Pro"],
      description: `
        I built several pieces of software for Orchard Market, a collaboration of 5 farms sharing warehousing and storefront space.\n\n
        
        The order picking software aggregated inventory across all 5 disparate inventory systems, allowing orders to be efficiently processed based on availability and delivery time. This reduced order fulfillment time by 15%.\n\n
        
        Depending on the inventory system, integrations were written in either JavaScript (for Excel-based systems) or C# (Produce Pro) to send data to a central server running Croptracker.\n\n
        
        Implemented phone image text recognition for handwritten order forms to quickly and accurately update the inventory system, reducing data entry errors by 50%. Python scripts extract handwriting from order forms, using QR codes to determine form types and apply appropriate analysis.\n\n
      `
    },
    {
      id: "mycology-lab",
      title: "Mycology Lab Technical Lead (2019-2022)",
      imagesFolder: "/assets/mycology-lab",
      langs: ["C++", "Bash", "Js", "G-Code"],
      software: ["Postgres", "Express", "React", "FluidNC", "OpenCV", "pm2"],
      description: `
        Fungal Stimuli Tester:\n\n
        Built a 3-axis gantry system that moves a central platform along an x,y plane with a winch that raises/lowers the end piece.\n\n
        The system features modular end effectors with multiple stimuli options including temperature probes, liquid dispensers, laser pointers, and more.\n\n
        Used 8 32-bit ADCs to record signal propagation within mycelial networks, with Fast Fourier Transform for spike detection and wavelet processing methods. \n\n
        Data logged to PostgreSQL for analysis. System built in C++.\n\n\n\n\n\n
        
        Mycelium Bioreactor:\n\n
        Automated bioreactor for growing liquid mycelium culture with automated temperature, oxygen, stirring, and harvesting control. Implemented sterilization systems and contamination detection using OpenCV computer vision. System built in C++.\n\n\n\n\n\n
        
        Growth Chamber:\n\n
        9-cell growth chamber with individual temperature control for each level, optimized for mycelial remediation experiments on contaminated cardboard. The system logged environmental variables and growth progress, allowing for optimization of growing conditions. System built in C++.
      `
    }
  ];
  
  export default projects;